export default {
  data() {
    return {
      availableFields: {}
    }
  },

  mounted() {
    this.availableFields = {
      'feature-blocks': [
        {
          field: 'image_alt_text',
          type: 'text',
          placeholder: 'My great image',
          hint: 'A description of your image that will help improve your SEO'
        },
        {
          field: 'heading',
          type: 'text',
          placeholder: 'e.g. Our Services'
        },
        {
          field: 'text',
          type: 'textarea'
        },
        {
          field: 'entry_animation',
          hint: 'How should the widget animate when scrolled into view?',
          type: 'select',
          options: [
            {
              key: 'None',
              value: 'none'
            },
            {
              key: 'Fade In',
              value: 'animate-fade-in'
            },
            {
              key: 'Scale In',
              value: 'animate-scale-in'
            },
            {
              key: 'Scale Out',
              value: 'animate-scale-out'
            },
            {
              key: 'Slide from Left',
              value: 'animate-slide-from-left'
            },
            {
              key: 'Slide from Right',
              value: 'animate-slide-from-right'
            },
            {
              key: 'Slide from Bottom',
              value: 'animate-slide-from-bottom'
            },
            {
              key: 'Slide from Top',
              value: 'animate-slide-from-top'
            }
          ]
        },
        {
          field: 'link',
          type: 'link',
          placeholder: 'e.g. /services',
          hint: 'Use the <strong>My Pages</strong> button to link to one of your pages, or use <strong>https</strong> to link to externally'
        },
        {
          field: 'link_text',
          type: 'text',
          placeholder: 'e.g. View Services',
          hint: 'This is text inside of the button'
        }
      ],

      'image-grid': [
        {
          field: 'image_alt_text',
          type: 'text',
          placeholder: 'My great image',
          hint: 'A description of your image that will help improve your SEO'
        },
        {
          field: 'heading',
          type: 'text',
          placeholder: 'e.g. Our Services'
        },
        {
          field: 'text',
          type: 'textarea',
          hint: 'This text will be shown when block is hovered on'
        },
        {
          field: 'link',
          type: 'link',
          placeholder: 'e.g. /services',
          hint: `Use the 'My Pages' button to link a page, or use <strong>https</strong> to link externally`
        },
        {
          field: 'link_text',
          type: 'text'
        }
      ],

      'basic-gallery': [
        {
          field: 'image_alt_text',
          type: 'text',
          placeholder: 'My great image',
          hint: 'A description of your image that will help improve your SEO'
        }
      ],

      slideshow: [
        {
          field: 'image_alt_text',
          type: 'text',
          placeholder: 'My great image',
          hint: 'A description of your image that will help improve your SEO'
        },
        {
          field: 'heading',
          type: 'text'
        },
        {
          field: 'sub_heading',
          type: 'text'
        },
        {
          field: 'text',
          type: 'text'
        },
        {
          field: 'slide_height',
          type: 'select',
          options: [
            {
              key: 'Full Screen',
              value: '100vh'
            },
            {
              key: 'Two Thirds',
              value: '66.666vh'
            },
            {
              key: 'Half Screen',
              value: '50vh'
            },
            {
              key: 'One Third',
              value: '33.333vh'
            },
            {
              key: 'One Quarter',
              value: '25vh'
            }
          ]
        },
        {
          field: 'slide_animation',
          type: 'select',
          options: [
            {
              key: 'None',
              value: 'none'
            },
            {
              key: 'Fade In',
              value: 'fadein'
            },
            {
              key: 'Zoom In',
              value: 'zoom-in'
            },
            {
              key: 'Zoom Out',
              value: 'zoom-out'
            },
            {
              key: 'Pan Up',
              value: 'pan-up'
            },
            {
              key: 'Pan Down',
              value: 'pan-down'
            },
            {
              key: 'Pan Left',
              value: 'pan-left'
            },
            {
              key: 'Pan Right',
              value: 'pan-right'
            }
          ]
        },
        {
          field: 'background_colour',
          type: 'color',
          hint: 'e.g. Blue or hex colour - #0000ff'
        },
        {
          field: 'button_link',
          type: 'link',
          placeholder: 'e.g. /services',
          hint: `Use the 'My Pages' button to link a page, or use <strong>https</strong> to link externally`
        },
        {
          field: 'button_text',
          type: 'text',
          hint: 'e.g. Contact Us!'
        }
      ],

      'mini-carousel': [
        {
          field: 'image_alt_text',
          type: 'text',
          placeholder: 'My great image',
          hint: 'A description of your image that will help improve your SEO'
        },
        {
          field: 'heading',
          type: 'text',
          hint: 'Main text on the slide'
        },
        {
          field: 'sub_heading',
          type: 'text',
          hint: 'Text below the heading'
        },
        {
          field: 'text',
          type: 'text',
          hint: 'A few words'
        },
        {
          field: 'background_colour',
          type: 'color',
          hint: 'e.g. Blue or hex colour - #0000ff'
        },
        {
          field: 'button_link',
          type: 'link',
          placeholder: 'e.g. /services',
          hint: `Use the 'My Pages' button to link a page, or use <strong>https</strong> to link externally`
        },
        {
          field: 'button_text',
          type: 'text',
          hint: 'e.g. Contact Us!'
        }
      ],

      'pricing-table': [
        {
          field: 'column_title',
          type: 'text',
          hint: 'e.g. Bronze Package'
        },
        {
          field: 'currency_symbol',
          type: 'text',
          hint: 'e.g. £ $ €'
        },
        {
          field: 'price',
          type: 'text',
          hint: 'The number Without the currency symbol'
        },
        {
          field: 'time_period',
          type: 'text',
          hint: 'e.g. Monthly or Hourly'
        },
        {
          field: 'colour',
          type: 'color',
          hint: 'e.g. Blue or hex colour - #0000ff'
        },
        {
          field: 'button_link',
          type: 'link',
          placeholder: 'e.g. /services',
          hint: `Use the 'My Pages' button to link a page, or use <strong>https</strong> to link externally`
        },
        {
          field: 'entry_animation',
          hint: 'How should the widget animate when scrolled into view?',
          type: 'select',
          options: [
            {
              key: 'None',
              value: 'none'
            },
            {
              key: 'Fade In',
              value: 'animate-fade-in'
            },
            {
              key: 'Scale In',
              value: 'animate-scale-in'
            },
            {
              key: 'Scale Out',
              value: 'animate-scale-out'
            },
            {
              key: 'Slide from Left',
              value: 'animate-slide-from-left'
            },
            {
              key: 'Slide from Right',
              value: 'animate-slide-from-right'
            },
            {
              key: 'Slide from Bottom',
              value: 'animate-slide-from-bottom'
            },
            {
              key: 'Slide from Top',
              value: 'animate-slide-from-top'
            }
          ]
        },
        {
          field: 'button_text',
          type: 'text',
          hint: 'e.g. Contact Us!'
        },
        {
          field: 'feature_1',
          type: 'text'
        },
        {
          field: 'feature_2',
          type: 'text'
        },
        {
          field: 'feature_3',
          type: 'text'
        },
        {
          field: 'feature_4',
          type: 'text'
        },
        {
          field: 'feature_5',
          type: 'text'
        },
        {
          field: 'feature_6',
          type: 'text'
        },
        {
          field: 'feature_7',
          type: 'text'
        },
        {
          field: 'feature_8',
          type: 'text'
        }
      ],

      accordion: [
        {
          field: 'heading',
          type: 'text',
          hint:
            'This is the clickable element which will show the hidden content. This is commonly used for frequently asked questions.'
        },
        {
          field: 'content',
          type: 'textarea',
          hint:
            'This is the hidden content that is activated when the heading is clicked. This could be an answer to a frequently asked question.'
        },
        {
          field: 'entry_animation',
          hint: 'How should the widget animate when scrolled into view?',
          type: 'select',
          options: [
            {
              key: 'None',
              value: 'none'
            },
            {
              key: 'Fade In',
              value: 'animate-fade-in'
            },
            {
              key: 'Scale In',
              value: 'animate-scale-in'
            },
            {
              key: 'Scale Out',
              value: 'animate-scale-out'
            },
            {
              key: 'Slide from Left',
              value: 'animate-slide-from-left'
            },
            {
              key: 'Slide from Right',
              value: 'animate-slide-from-right'
            },
            {
              key: 'Slide from Bottom',
              value: 'animate-slide-from-bottom'
            },
            {
              key: 'Slide from Top',
              value: 'animate-slide-from-top'
            }
          ]
        }
      ],

      tabs: [
        {
          field: 'tab_heading',
          type: 'text',
          hint: 'This is the title of the tab'
        },
        {
          field: 'content',
          type: 'textarea',
          hint:
            'This is the main content of the tab that is hidden until the tab has been activated'
        }
      ],

      'product-list': [
        {
          field: 'image_alt_text',
          type: 'text',
          placeholder: 'My great image',
          hint: 'A description of your image that will help improve your SEO'
        },
        {
          field: 'product_title',
          type: 'text',
          placeholder: 'Nike Shoes',
          hint: 'A descriptive title for your product'
        },
        {
          field: 'product_category',
          type: 'text',
          placeholder: 'e.g. Shoes, Accessories or Mens',
          hint: 'This will place this product into a category with other products which share the same category'
        },
        {
          field: 'product_currency',
          type: 'select',
          placeholder: 'Nike Shoes',
          hint: 'What currency are you selling this product in?',
          options: [
            {key: 'GBP (£)', value: '£'},
            {key: 'USD ($)', value: '$'},
            {key: 'CAD (C$)', value: 'C$'},
            {key: 'EURO (€)', value: '€'},
            {key: 'Yen (¥)', value: '¥'}
          ]
        },
        {
          field: 'product_price',
          type: 'text',
          placeholder: '100',
          hint: 'How much are you selling this product for? This will be added to the total amount'
        },
        {
          field: 'product_compare_price',
          type: 'text',
          placeholder: '150',
          hint: 'When you put a product on sale for a lower price, you might want your customers to be able to see the original price'
        },
        {
          field: 'product_description',
          type: 'textarea'
        },
        {
          field: 'text_position',
          type: 'select',
          hint:
            'You can control where you would like to position the text on desktop',
          options: [
            {key: 'Right', value: 'text-right'},
            {key: 'Left', value: 'text-left'}
          ]
        },
        {
          field: 'text_width',
          type: 'select',
          hint:
            'By setting the text width, the image will fill the remaining space. Desktop only.',
          options: [
            {key: 'One Third', value: 'one-third'},
            {key: 'Half', value: 'half'},
            {key: 'Two Thirds', value: 'two-thirds'},
            {key: 'Three Quarters', value: 'three-quarters'}
          ]
        },
        {
          field: 'text_alignment',
          type: 'select',
          hint:
            'How would you like to vertically align your text? <strong>Middle</strong> is recommended',
          options: [
            {key: 'Top', value: 'align-top'},
            {key: 'Middle', value: 'align-middle'},
            {key: 'Bottom', value: 'align-bottom'}
          ]
        },
        {
          field: 'fixed_image_height',
          type: 'checkbox',
          hint: 'Crop the image height'
        },
        {
          field: 'boxed',
          type: 'checkbox',
          hint: 'This option adds a background to your text'
        },
        {
          field: 'bottom_spacing',
          type: 'checkbox',
          hint:
            "If you're going to add more items in this page section, you might want to add spacing below"
        }
      ],

      'text-image': [
        {
          field: 'image_alt_text',
          type: 'text',
          placeholder: 'My great image',
          hint: 'A description of your image that will help improve your SEO'
        },
        {
          field: 'text',
          type: 'textarea'
        },
        {
          field: 'text_position',
          type: 'select',
          hint:
            'You can control where you would like to position the text on desktop',
          options: [
            {key: 'Right', value: 'text-right'},
            {key: 'Left', value: 'text-left'}
          ]
        },
        {
          field: 'text_width',
          type: 'select',
          hint:
            'By setting the text width, the image will fill the remaining space. Desktop only.',
          options: [
            {key: 'One Third', value: 'one-third'},
            {key: 'Half', value: 'half'},
            {key: 'Two Thirds', value: 'two-thirds'},
            {key: 'Three Quarters', value: 'three-quarters'}
          ]
        },
        {
          field: 'text_alignment',
          type: 'select',
          hint:
            'How would you like to vertically align your text? <strong>Middle</strong> is recommended',
          options: [
            {key: 'Top', value: 'align-top'},
            {key: 'Middle', value: 'align-middle'},
            {key: 'Bottom', value: 'align-bottom'}
          ]
        },
        {
          field: 'entry_animation',
          hint: 'How should the widget animate when scrolled into view?',
          type: 'select',
          options: [
            {
              key: 'None',
              value: 'none'
            },
            {
              key: 'Fade In',
              value: 'animate-fade-in'
            },
            {
              key: 'Scale In',
              value: 'animate-scale-in'
            },
            {
              key: 'Scale Out',
              value: 'animate-scale-out'
            },
            {
              key: 'Slide from Left',
              value: 'animate-slide-from-left'
            },
            {
              key: 'Slide from Right',
              value: 'animate-slide-from-right'
            },
            {
              key: 'Slide from Bottom',
              value: 'animate-slide-from-bottom'
            },
            {
              key: 'Slide from Top',
              value: 'animate-slide-from-top'
            }
          ]
        },
        {
          field: 'fixed_image_height',
          type: 'checkbox',
          hint: 'Crop the image height'
        },
        {
          field: 'boxed',
          type: 'checkbox',
          hint: 'This option adds a background to your text'
        },
        {
          field: 'bottom_spacing',
          type: 'checkbox',
          hint:
            "If you're going to add more items in this page section, you might want to add spacing below"
        }
      ],

      'html-code': [
        {
          field: 'html_code',
          type: 'code',
          hint:
            'You can write HTML code here. You can embed third party widgets such as a YouTube video or booking form'
        }
      ],

      'text-content': [
        {
          field: 'text',
          type: 'textarea',
          hint: 'A simple block of text'
        },
        {
          field: 'entry_animation',
          hint: 'How should the widget animate when scrolled into view?',
          type: 'select',
          options: [
            {
              key: 'None',
              value: 'none'
            },
            {
              key: 'Fade In',
              value: 'animate-fade-in'
            },
            {
              key: 'Scale In',
              value: 'animate-scale-in'
            },
            {
              key: 'Scale Out',
              value: 'animate-scale-out'
            },
            {
              key: 'Slide from Left',
              value: 'animate-slide-from-left'
            },
            {
              key: 'Slide from Right',
              value: 'animate-slide-from-right'
            },
            {
              key: 'Slide from Bottom',
              value: 'animate-slide-from-bottom'
            },
            {
              key: 'Slide from Top',
              value: 'animate-slide-from-top'
            }
          ]
        },
        {
          field: 'columns',
          type: 'select',
          hint: 'The number of columns. This will only show on desktop',
          options: [
            {key: '1', value: '1'},
            {key: '2', value: '2'},
            {key: '3', value: '3'},
            {key: '4', value: '4'}
          ]
        },
        {
          field: 'column_borders',
          type: 'checkbox',
          hint: 'Add a divider to the columns?'
        },
        {
          field: 'boxed',
          type: 'checkbox',
          hint: 'This option adds a background to your text'
        }
      ],

      'image-cards': [
        {
          field: 'image_alt_text',
          type: 'text',
          placeholder: 'My great image',
          hint: 'A description of your image that will help improve your SEO'
        },
        {
          field: 'heading',
          type: 'text',
          hint: 'e.g. Our Latest Work'
        },
        {
          field: 'text',
          type: 'textarea',
          hint: 'e.g. Check out the latest work in our gallery!'
        },
        {
          field: 'entry_animation',
          hint: 'How should the widget animate when scrolled into view?',
          type: 'select',
          options: [
            {
              key: 'None',
              value: 'none'
            },
            {
              key: 'Fade In',
              value: 'animate-fade-in'
            },
            {
              key: 'Scale In',
              value: 'animate-scale-in'
            },
            {
              key: 'Scale Out',
              value: 'animate-scale-out'
            },
            {
              key: 'Slide from Left',
              value: 'animate-slide-from-left'
            },
            {
              key: 'Slide from Right',
              value: 'animate-slide-from-right'
            },
            {
              key: 'Slide from Bottom',
              value: 'animate-slide-from-bottom'
            },
            {
              key: 'Slide from Top',
              value: 'animate-slide-from-top'
            }
          ]
        },
        {
          field: 'link',
          type: 'link',
          placeholder: 'e.g. /services',
          hint: `Use the 'My Pages' button to link a page, or use <strong>https</strong> to link externally`
        },
        {
          field: 'link_text',
          type: 'text',
          hint: 'e.g. View Gallery'
        }
      ],

      'simple-form': [
        {
          field: 'label',
          type: 'text',
          hint: 'e.g. Contact Number'
        },
        {
          field: 'field_type',
          type: 'select',
          linking: true,
          options: [
            {key: 'Text Field', value: 'form-text'},
            {key: 'Text Box', value: 'form-textarea'},
            {key: 'Dropdown', value: 'form-select'},
            {key: 'Checkbox', value: 'form-checkbox'}
          ],
          hint: 'What is the type of field?'
        },
        {
          field: 'text_placeholder',
          dataId: 'form-text',
          dataGroup: 'field-type',
          type: 'text',
          hint: 'A hint for your visitor',
          placeholder: 'This text is a placeholder!'
        },
        {
          field: 'textarea_placeholder',
          dataId: 'form-textarea',
          dataGroup: 'field-type',
          type: 'text',
          hint: 'A hint for your visitor',
          placeholder: 'This text is a placeholder!'
        },
        {
          field: 'dropdown_options',
          dataId: 'form-select',
          dataGroup: 'field-type',
          type: 'text',
          hint: 'Seperate options with commas',
          placeholder: 'Option 1, Option 2, Option 3'
        },
        {
          field: 'automatically_checked',
          dataId: 'form-checkbox',
          dataGroup: 'field-type',
          type: 'select',
          hint: 'Should the checkbox be checked automatically?',
          options: [
            {key: 'Yes, check it', value: 'true'},
            {key: 'No, leave it unchecked', value: 'false'}
          ]
        }
      ],

      'landing-form': [
        {
          field: 'image_alt_text',
          type: 'text',
          placeholder: 'My great image',
          hint: 'A description of your image that will help improve your SEO'
        },
        {
          field: 'image_animation',
          type: 'select',
          options: [
            {
              key: 'None',
              value: 'none'
            },
            {
              key: 'Zoom In',
              value: 'zoom-in'
            },
            {
              key: 'Zoom Out',
              value: 'zoom-out'
            },
            {
              key: 'Pan Up',
              value: 'pan-up'
            },
            {
              key: 'Pan Down',
              value: 'pan-down'
            },
            {
              key: 'Pan Left',
              value: 'pan-left'
            },
            {
              key: 'Pan Right',
              value: 'pan-right'
            }
          ]
        },
        {
          field: 'heading',
          type: 'text',
          placeholder: 'Top Plumber in London',
          hint: 'A catchy call to action'
        },
        {
          field: 'sub_heading',
          type: 'text',
          placeholder: '24/7 callout',
          hint: 'This heading will sit below the main heading'
        },
        {
          field: 'content',
          type: 'textarea',
          hint: `Grab attention by showing your customers what you're offering. You can copy/paste emojis<br>👉 ⭐️ ⚡️ 💥 🔥 ✅ ✔️ ☑️ ➡️ ★ ☆ ✪ ➔ ➞`
        },
        {
          field: 'landing_form_style',
          type: 'select',
          hint: 'Choose a style from the available options',
          options: [
            {key: 'Style One', value: 'landing-form-one'},
            {key: 'Style Two', value: 'landing-form-two'}
          ]
        },
        {
          field: 'text_position_desktop',
          type: 'select',
          hint: 'Should thet text display on the left or right of the form?',
          options: [
            {key: 'Left of the form', value: 'text-left'},
            {key: 'Right of the form', value: 'text-right'}
          ]
        },
        {
          field: 'text_width_desktop',
          type: 'select',
          hint:
            'By setting the text width, the image will fill the remaining space. Desktop only.',
          options: [
            {key: 'One Third', value: 'one-third'},
            {key: 'Half', value: 'half'},
            {key: 'Three Fifths', value: 'three-fifths'},
            {key: 'Two Thirds', value: 'two-thirds'}
          ]
        },
        {
          field: 'text_position_mobile',
          type: 'select',
          hint: 'Should the text display above or below the form?',
          options: [
            {key: 'Above the form', value: 'text-above'},
            {key: 'Below the form', value: 'text-below'}
          ]
        },
        {
          field: 'display_phone_field',
          type: 'select',
          hint: 'Allow customers to submit their phone number. Recommended!',
          options: [
            {key: 'Yes', value: 'true'},
            {key: 'No', value: 'false'}
          ]
        },
        {
          field: 'custom_field_label_1',
          type: 'text',
          hint: 'e.g. What services are you interested in?'
        },
        {
          field: 'custom_field_type_1',
          type: 'select',
          linking: true,
          options: [
            {key: 'Text Field', value: 'form-text-1'},
            {key: 'Text Box', value: 'form-textarea-1'},
            {key: 'Dropdown', value: 'form-select-1'}
          ],
          hint: 'What is the type of field?'
        },
        {
          field: 'custom_field_options_1',
          dataId: 'form-select-1',
          dataGroup: 'custom-field-type-1',
          type: 'text',
          hint: 'Seperate options with commas',
          placeholder: 'Option 1, Option 2, Option 3'
        },
        {
          field: 'custom_field_text_placeholder_1',
          placeholder: 'This is a placeholder',
          type: 'text',
          hint: 'Some placeholder text to give an example of data you require',
          dataId: 'form-text-1',
          dataGroup: 'custom-field-type-1'
        },
        {
          field: 'custom_field_text_box_placeholder_1',
          placeholder: 'This is a placeholder',
          type: 'text',
          hint: 'Some placeholder text to give an example of data you require',
          dataId: 'form-textarea-1',
          dataGroup: 'custom-field-type-1'
        },
        {
          field: 'custom_field_label_2',
          type: 'text',
          hint: 'e.g. What services are you interested in?'
        },
        {
          field: 'custom_field_type_2',
          type: 'select',
          linking: true,
          options: [
            {key: 'Text Field', value: 'form-text-2'},
            {key: 'Text Box', value: 'form-textarea-2'},
            {key: 'Dropdown', value: 'form-select-2'}
          ],
          hint: 'What is the type of field?'
        },
        {
          field: 'custom_field_options_2',
          dataId: 'form-select-2',
          dataGroup: 'custom-field-type-2',
          type: 'text',
          hint: 'Seperate options with commas',
          placeholder: 'Option 1, Option 2, Option 3'
        },
        {
          field: 'custom_field_text_placeholder_2',
          placeholder: 'This is a placeholder',
          type: 'text',
          hint: 'Some placeholder text to give an example of data you require',
          dataId: 'form-text-2',
          dataGroup: 'custom-field-type-2'
        },
        {
          field: 'custom_field_text_box_placeholder_2',
          placeholder: 'This is a placeholder',
          type: 'text',
          hint: 'Some placeholder text to give an example of data you require',
          dataId: 'form-textarea-2',
          dataGroup: 'custom-field-type-2'
        },
        {
          field: 'custom_field_label_3',
          type: 'text',
          hint: 'e.g. What services are you interested in?'
        },
        {
          field: 'custom_field_type_3',
          type: 'select',
          linking: true,
          options: [
            {key: 'Text Field', value: 'form-text-3'},
            {key: 'Text Box', value: 'form-textarea-3'},
            {key: 'Dropdown', value: 'form-select-3'}
          ],
          hint: 'What is the type of field?'
        },
        {
          field: 'custom_field_options_3',
          dataId: 'form-select-3',
          dataGroup: 'custom-field-type-3',
          type: 'text',
          hint: 'Seperate options with commas',
          placeholder: 'Option 1, Option 2, Option 3'
        },
        {
          field: 'custom_field_text_placeholder_3',
          placeholder: 'This is a placeholder',
          type: 'text',
          hint: 'Some placeholder text to give an example of data you require',
          dataId: 'form-text-3',
          dataGroup: 'custom-field-type-3'
        },
        {
          field: 'custom_field_text_box_placeholder_3',
          placeholder: 'This is a placeholder',
          type: 'text',
          hint: 'Some placeholder text to give an example of data you require',
          dataId: 'form-textarea-3',
          dataGroup: 'custom-field-type-3'
        },
        {
          field: 'custom_field_label_4',
          type: 'text',
          hint: 'e.g. What services are you interested in?'
        },
        {
          field: 'custom_field_type_4',
          type: 'select',
          linking: true,
          options: [
            {key: 'Text Field', value: 'form-text-4'},
            {key: 'Text Box', value: 'form-textarea-4'},
            {key: 'Dropdown', value: 'form-select-4'}
          ],
          hint: 'What is the type of field?'
        },
        {
          field: 'custom_field_options_4',
          dataId: 'form-select-4',
          dataGroup: 'custom-field-type-4',
          type: 'text',
          hint: 'Seperate options with commas',
          placeholder: 'Option 1, Option 2, Option 3'
        },
        {
          field: 'custom_field_text_placeholder_4',
          placeholder: 'This is a placeholder',
          type: 'text',
          hint: 'Some placeholder text to give an example of data you require',
          dataId: 'form-text-4',
          dataGroup: 'custom-field-type-4'
        },
        {
          field: 'custom_field_text_box_placeholder_4',
          placeholder: 'This is a placeholder',
          type: 'text',
          hint: 'Some placeholder text to give an example of data you require',
          dataId: 'form-textarea-4',
          dataGroup: 'custom-field-type-4'
        },
        {
          field: 'custom_field_label_5',
          type: 'text',
          hint: 'e.g. What services are you interested in?'
        },
        {
          field: 'custom_field_type_5',
          type: 'select',
          linking: true,
          options: [
            {key: 'Text Field', value: 'form-text-5'},
            {key: 'Text Box', value: 'form-textarea-5'},
            {key: 'Dropdown', value: 'form-select-5'}
          ],
          hint: 'What is the type of field?'
        },
        {
          field: 'custom_field_options_5',
          dataId: 'form-select-5',
          dataGroup: 'custom-field-type-5',
          type: 'text',
          hint: 'Seperate options with commas',
          placeholder: 'Option 1, Option 2, Option 3'
        },
        {
          field: 'custom_field_text_placeholder_5',
          placeholder: 'This is a placeholder',
          type: 'text',
          hint: 'Some placeholder text to give an example of data you require',
          dataId: 'form-text-5',
          dataGroup: 'custom-field-type-5'
        },
        {
          field: 'custom_field_text_box_placeholder_5',
          placeholder: 'This is a placeholder',
          type: 'text',
          hint: 'Some placeholder text to give an example of data you require',
          dataId: 'form-textarea-5',
          dataGroup: 'custom-field-type-5'
        }
      ],

      'team-members': [
        {
          field: 'image_alt_text',
          type: 'text',
          placeholder: 'My great image',
          hint: 'A description of your image that will help improve your SEO'
        },
        {
          field: 'name',
          type: 'text',
          placeholder: 'e.g. John Smith'
        },
        {
          field: 'job_role',
          type: 'text',
          placeholder: 'e.g. General Manager'
        },
        {
          field: 'bio',
          type: 'textarea',
          placeholder: 'Some information about this team member'
        },
        {
          field: 'phone_number',
          type: 'text'
        },
        {
          field: 'email_address',
          type: 'text'
        },
        {
          field: 'facebook_username',
          type: 'text'
        },
        {
          field: 'instagram_username',
          type: 'text'
        },
        {
          field: 'twitter_username',
          type: 'text'
        },
        {
          field: 'youtube_username',
          type: 'text'
        },
        {
          field: 'snapchat_username',
          type: 'text'
        },
        {
          field: 'pinterest_username',
          type: 'text'
        },
        {
          field: 'linkedin_username',
          type: 'text'
        },
        {
          field: 'entry_animation',
          hint: 'How should the widget animate when scrolled into view?',
          type: 'select',
          options: [
            {
              key: 'None',
              value: 'none'
            },
            {
              key: 'Fade In',
              value: 'animate-fade-in'
            },
            {
              key: 'Scale In',
              value: 'animate-scale-in'
            },
            {
              key: 'Scale Out',
              value: 'animate-scale-out'
            },
            {
              key: 'Slide from Left',
              value: 'animate-slide-from-left'
            },
            {
              key: 'Slide from Right',
              value: 'animate-slide-from-right'
            },
            {
              key: 'Slide from Bottom',
              value: 'animate-slide-from-bottom'
            },
            {
              key: 'Slide from Top',
              value: 'animate-slide-from-top'
            }
          ]
        }
      ],

      reviews: [
        {
          field: 'review',
          type: 'textarea'
        },
        {
          field: 'author',
          type: 'text'
        },
        {
          field: 'entry_animation',
          hint: 'How should the widget animate when scrolled into view?',
          type: 'select',
          options: [
            {
              key: 'None',
              value: 'none'
            },
            {
              key: 'Fade In',
              value: 'animate-fade-in'
            },
            {
              key: 'Scale In',
              value: 'animate-scale-in'
            },
            {
              key: 'Scale Out',
              value: 'animate-scale-out'
            },
            {
              key: 'Slide from Left',
              value: 'animate-slide-from-left'
            },
            {
              key: 'Slide from Right',
              value: 'animate-slide-from-right'
            },
            {
              key: 'Slide from Bottom',
              value: 'animate-slide-from-bottom'
            },
            {
              key: 'Slide from Top',
              value: 'animate-slide-from-top'
            }
          ]
        }
      ],

      'shop-collection': [
        {
          field: 'collection_slug',
          type: 'text',
          hint:
            'Create a collection in Shopify and use the collection slug here.<br><em>shop-name</em>.myshopify.com/admin/collections',
          placeholder: 'e.g. mens-summer-sale'
        }
      ],

      'youtube-videos': [
        {
          field: 'video_url',
          type: 'text',
          hint:
            'Simply copy and paste the website address of the YouTube video',
          placeholder: 'https://www.youtube.com/watch?v=GJOAlNAnR_c'
        }
      ],

      alert: [
        {
          field: 'content',
          type: 'text',
          placeholder:
            'All orders will be now dispatched after the bank holiday Monday. Thank you!'
        },
        {
          field: 'type',
          type: 'select',
          options: [
            {key: 'General', value: 'general'},
            {key: 'Error', value: 'error'},
            {key: 'Success', value: 'success'},
            {key: 'Notice', value: 'notice'}
          ],
          placeholder:
            'All orders will be now dispatched after the bank holiday Monday. Thank you!'
        },
        {
          field: 'entry_animation',
          hint: 'How should the widget animate when scrolled into view?',
          type: 'select',
          options: [
            {
              key: 'None',
              value: 'none'
            },
            {
              key: 'Fade In',
              value: 'animate-fade-in'
            },
            {
              key: 'Scale In',
              value: 'animate-scale-in'
            },
            {
              key: 'Scale Out',
              value: 'animate-scale-out'
            },
            {
              key: 'Slide from Left',
              value: 'animate-slide-from-left'
            },
            {
              key: 'Slide from Right',
              value: 'animate-slide-from-right'
            },
            {
              key: 'Slide from Bottom',
              value: 'animate-slide-from-bottom'
            },
            {
              key: 'Slide from Top',
              value: 'animate-slide-from-top'
            }
          ]
        }
      ],

      'section-separator': [
        {
          field: 'style',
          type: 'select',
          options: [
            {key: 'Slant', value: 'slant'},
            {key: 'Clouds', value: 'clouds'},
            {key: 'Hills', value: 'hills'}
          ]
        },
        {
          field: 'flip_vertical',
          type: 'checkbox'
        },
        {
          field: 'flip_horizontal',
          type: 'checkbox'
        }
      ]
    }

    this.fieldsLoaded = true
  }
}
